module.exports = __webpack_public_path__ + "home-popup-close-d56650a0.png";